import { Box, Typography } from "@material-ui/core";
import { Fragment, useEffect, useState } from "react";
import { BotaoCadastrarPeriodo } from "./components/BotaoCadastrarPeriodo";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { TipoPrograma } from "./__enum";
import { ListaProps } from "./__types";

interface ProgramaEscolaProps {
    tipoPrograma: TipoPrograma;
    carregarDados: any;
    carregarPeriodos: (id: number) => any;
    ListaComponent: React.ComponentType<ListaProps>;
    listaCooperativaEscolar?: React.ReactNode;
    titulo?: React.ReactNode;
    descricao?: React.ReactNode;
    botaoExtra?: React.ReactNode;
}

export const ProgramaEscola = ({
    tipoPrograma,
    carregarDados,
    carregarPeriodos,
    ListaComponent,
    listaCooperativaEscolar,
    titulo,
    descricao,
    botaoExtra,
}: ProgramaEscolaProps) => {
    const { id } = useParams<{ id: string }>();
    const [refreshLista, setRefreshLista] = useState(0);
    const [paginaAtual, setPaginaAtual] = useState(1);
    const dadosDaEscola = useSelector((state: RootState) => state.escolas.dadosDaEscola);
    const totalPages = useSelector((state: RootState) => state.escolas.pagePeriodoEscola.totalPages);
    const totalElements = useSelector((state: RootState) => state.escolas.pagePeriodoEscola.totalElements);
    const atualizaLista = () => setRefreshLista(prev => prev + 1)
    const dispatch = useDispatch();

    useEffect(() => {
        if (id) {
            dispatch(carregarDados(Number(id), paginaAtual));
            dispatch(carregarPeriodos(Number(id)));
        }
    }, [carregarDados, carregarPeriodos, dispatch, id, paginaAtual, refreshLista]);

    const getPeriodos = () => Array.isArray(dadosDaEscola) ? dadosDaEscola : [];

    return (
        <Fragment>
            {titulo && (
                <Box className="renderTableCoop_container-title">
                    <Typography className="renderTableCoop_label--big">{titulo}</Typography>
                    <Typography className="renderTableCoop_label--small">{descricao}</Typography>
                </Box>
            )}

            {botaoExtra && <Box className="renderTableCoop_container-button">{botaoExtra}</Box>}

            {listaCooperativaEscolar}

            <BotaoCadastrarPeriodo
                tipoPrograma={tipoPrograma}
                onRefresh={atualizaLista}
            />

            {getPeriodos().length > 0 && (
                <ListaComponent
                    id={id}
                    periodos={getPeriodos()}
                    paginaAtual={paginaAtual}
                    setPaginaAtual={setPaginaAtual}
                    totalPages={totalPages}
                    totalElements={totalElements}
                    onRefresh={atualizaLista}
                />
            )}
        </Fragment>
    );
};
